import React, { Fragment } from "react";

const withContentSection = WrappedComponent => props => (
  <Fragment>
    <WrappedComponent {...props} />
  </Fragment>
);

export default withContentSection;
